// This file was generated by lezer-generator. You probably shouldn't edit it.
import { LRParser } from "@lezer/lr";
export const datatableFormulaParser = LRParser.deserialize({
  version: 14,
  states:
    "#`OVQPOOQbQPOOOVQPO'#C`OOQO'#Cj'#CjOOQO'#Ca'#CaOOQO'#Cb'#CbOOQO'#Cc'#CcOOQO'#Cd'#CdOVQPO,58zOVQPO,58zObQPO,58zOOQO1G.f1G.fOpQPO1G.fOVQPO1G.fOVQPO1G.fO!UQPO7+$QO!gQPO7+$QOOQO<<Gl<<Gl",
  stateData:
    "!x~O]OS~OQRORROXQO~O_SO`TOaUObVO~O_SO`TOZSiaSibSiYSi~OYaO_Si`SiaSibSi~OYaO_SO`TOaSibSi~O",
  goto: "!Y_PPPP`hhppPPPPPv]ROQWX]^UWP[`R]YQXPR^YQPOQYQQZWQ[XQ_]R`^",
  nodeNames:
    "⚠ Formula Number Variable NumericExpression MultiplicationOperator DivisionOperator AdditionOperator SubtractionOperator OpeningBracket ClosingBracket",
  maxTerm: 18,
  skippedNodes: [0],
  repeatNodeCount: 0,
  tokenData:
    "%q~RbX^!Zpq!Ztu#Oxy#pyz#uz{#z{|$P}!O$U!P!Q$Z!Q![$`#y#z!Z$f$g!Z#BY#BZ!Z$IS$I_!Z$I|$JO!Z$JT$JU!Z$KV$KW!Z&FU&FV!Z~!`Y]~X^!Zpq!Z#y#z!Z$f$g!Z#BY#BZ!Z$IS$I_!Z$I|$JO!Z$JT$JU!Z$KV$KW!Z&FU&FV!Z~#RS!Q![#_!c!}#_#R#S#_#T#o#_~#dSR~!Q![#_!c!}#_#R#S#_#T#o#_~#uOX~~#zOY~~$PO_~~$UOa~~$ZOb~~$`O`~~$eSQ~!O!P$q!Q![$`!g!h%V#X#Y%V~$tP!Q![$w~$|RQ~!Q![$w!g!h%V#X#Y%V~%YR{|%c}!O%c!Q![%i~%fP!Q![%i~%nPQ~!Q![%i",
  tokenizers: [0],
  topRules: { Formula: [0, 1] },
  tokenPrec: 0,
  termNames: {
    "0": "⚠",
    "1": "@top",
    "2": "Number",
    "3": "Variable",
    "4": "NumericExpression",
    "5": "MultiplicationOperator",
    "6": "DivisionOperator",
    "7": "AdditionOperator",
    "8": "SubtractionOperator",
    "9": "OpeningBracket",
    "10": "ClosingBracket",
    "11": "␄",
    "12": "%mainskip",
    "13": "space",
    "14": "expression",
    "15": '"*"',
    "16": '"/"',
    "17": '"+"',
    "18": '"-"',
  },
});
